let csrfToken = "";

export function setCsrfToken(value) {
  csrfToken = value || "";
}

export async function request(path, options = {}) {
  const { timeoutMs = 15000, ...fetchOptions } = options;
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), timeoutMs);
  const headers = {
    Accept: "application/json",
    ...(fetchOptions.body ? { "Content-Type": "application/json" } : {}),
    ...(csrfToken ? { "X-CSRF-TOKEN": csrfToken } : {}),
    ...fetchOptions.headers,
  };
  let response;

  try {
    response = await fetch(path, {
      credentials: "same-origin",
      ...fetchOptions,
      headers,
      signal: controller.signal,
    });
  } catch (error) {
    if (error?.name === "AbortError") {
      throw new Error(
        "CapDeskPro is taking longer than expected. Please try again.",
      );
    }

    throw error;
  } finally {
    window.clearTimeout(timeout);
  }

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const messages = payload.errors ? Object.values(payload.errors).flat() : [];
    const error = new Error(
      messages[0] || payload.message || "The request failed.",
    );
    error.status = response.status;
    throw error;
  }

  return payload;
}

export const get = (path) => request(path);
export const post = (path, body) =>
  request(path, { method: "POST", body: JSON.stringify(body) });
export const patch = (path, body) =>
  request(path, { method: "PATCH", body: JSON.stringify(body) });
export const del = (path) => request(path, { method: "DELETE" });
